/* eslint-disable object-curly-newline */
import userApi from '@/api/user';
import {
  storeActionCommit,
} from '@/utils/common-utils';

const {
  v4: uuidv4,
} = require('uuid');

export default {
  authenticate({ commit }, { username, password, errorManagementType }) {
    return userApi.authenticate({ username, password }, errorManagementType)
      .then((user) => {
        localStorage.setItem("access-token", user.token);
        localStorage.setItem("user", JSON.stringify({id: user.id, user: { id: user.user.id, firstName: user.user.firstName, lastName: user.user.lastName, email: user.user.email } }));  
        
        sessionStorage.setItem("access-token", user.token);
        sessionStorage.setItem("user", JSON.stringify({id: user.id, user: { id: user.user.id, firstName: user.user.firstName, lastName: user.user.lastName, email: user.user.email } }));
        // Load user's newsletter preference from localStorage
        const userKey = `newsletter_${user.email}`;
        const newsletterPreference = localStorage.getItem(userKey);
  
        const userWithNewsletter = {
          ...user,
          newsletter: newsletterPreference === "true", // Convert to boolean
        };
        storeActionCommit(commit, "setUser")(userWithNewsletter);
      });
  },

  register({ commit }, { register, errorManagementType }) {
    return userApi.create(register, errorManagementType)
      .then((user) => {
        localStorage.setItem('access-token', user.token);
        localStorage.setItem('user', JSON.stringify({id: user.id, user: { id: user.user.id, firstName: user.user.firstName, lastName: user.user.lastName, email: user.user.email } }));
        storeActionCommit(commit, 'setUser')(user);
      });
  },

  setUserProfile({ commit }, user) {
    return storeActionCommit(commit, 'setUser')(user);
  },

  logout({ commit }) {
    commit('setUser', null);
    localStorage.removeItem('access-token');
    localStorage.removeItem('user');
    // localStorage.removeItem('actualCountryCode');
    localStorage.removeItem(window.processEnv.VUE_APP_SHOPPING_CART_TEMP_USER);
    localStorage.removeItem(window.processEnv.VUE_APP_SHOPPING_CART_TEMP_USER_EMAIL);
  },

  createTempUser({ commit }) {
    let xTmp = localStorage.getItem(window.processEnv.VUE_APP_SHOPPING_CART_TEMP_USER);
    let xEmail = localStorage.getItem(window.processEnv.VUE_APP_SHOPPING_CART_TEMP_USER_EMAIL);

    if (!xTmp) {
      xTmp = uuidv4();
      localStorage.setItem(window.processEnv.VUE_APP_SHOPPING_CART_TEMP_USER, xTmp);
    }
    if (!xEmail) {
      // xEmail = `test-${Math.floor(Math.random() * 100000)}@boires.ca`;
      // xEmail = `${xTmp}`;
      xEmail = `${xTmp}@boires.ca`;
      localStorage.setItem(window.processEnv.VUE_APP_SHOPPING_CART_TEMP_USER_EMAIL, xEmail);
    }

    return storeActionCommit(commit, 'createTempUser')({ id: xTmp, email: xEmail });
  },

  getUserDetails({ commit }, { customerId, userData, errorManagementType }) {
    return userApi.getUserDetails(customerId, userData, errorManagementType)
      .then((userDetails) => {
        commit('setUserDetails', userDetails); // Commit to mutation
        return userDetails;
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
        throw error;
      });
  },
};
